import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, NavigationEnd, Router, RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { filter } from 'rxjs';

export interface AppBreadcrumb {
  label: string;
  url: string;
}

/** Routen-Angabe `data.breadcrumbSuffix`: Krumen nach dem Label der Route, etwa aus Query-Parametern. */
export type BreadcrumbSuffix = (route: ActivatedRouteSnapshot) => AppBreadcrumb[];

@Component({
  selector: 'app-breadcrumb',
  standalone: true,
  imports: [RouterLink, TranslatePipe],
  templateUrl: './app-breadcrumb.component.html',
  styleUrl: './app-breadcrumb.component.scss',
})
export class AppBreadcrumbComponent implements OnInit {
  private router = inject(Router);
  private route = inject(ActivatedRoute);

  breadcrumbs: AppBreadcrumb[] = [];

  ngOnInit(): void {
    this.breadcrumbs = this.build(this.route.root.snapshot);
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
      this.breadcrumbs = this.build(this.route.root.snapshot);
    });
  }

  private build(snapshot: ActivatedRouteSnapshot, parentUrl = ''): AppBreadcrumb[] {
    const result: AppBreadcrumb[] = [];
    for (const child of snapshot.children) {
      const routePath = child.url.map((s) => s.path).join('/');
      const url = routePath ? `${parentUrl}/${routePath}` : parentUrl;

      const prefix = child.data['breadcrumbPrefix'] as AppBreadcrumb[] | undefined;
      if (Array.isArray(prefix)) {
        result.push(...prefix);
      }

      const label = child.data['breadcrumb'];
      if (label) {
        result.push({ label, url });
      }
      const suffix = child.data['breadcrumbSuffix'] as BreadcrumbSuffix | undefined;
      if (typeof suffix === 'function') {
        result.push(...suffix(child));
      }
      result.push(...this.build(child, url));
    }
    return result;
  }
}
